import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CoreMaterialModule } from '@nttp/core-material';
import { CoreUiModule } from '@nttp/core-ui';
import { AddNewRecipientStep1Component } from '@pg-app/client/manage-recipient/components/add-new-recipient/step-1/step-1.component';
import { AddNewRecipientStep2Component } from '@pg-app/client/manage-recipient/components/add-new-recipient/step-2/step-2.component';
import { AddNewRecipientVerifyCodeComponent } from '@pg-app/client/manage-recipient/components/add-new-recipient/verify-code/verify-code.component';
import { ManageRecipientComponent } from '@pg-app/client/manage-recipient/containers/manage-recipient.component';
import { ManageRecipientRoutingModule } from '@pg-app/client/manage-recipient/manage-recipient-routing.module';
import { NgTableModule } from '@nttp/table/ng-table.module';
import { VerifyPasscodeComponent } from '@pg-app/client/manage-recipient/containers/verify-passcode/verify-passcode.component';
import { SendPaymentModalModule } from '@pg-app/client/client-dashboard/components/send-payment-modal/send-payment-modal.module';
import { PipeModule } from '@nttp/pipes/pipe.module';
import { PinTwillioAuthyModule } from '@pg-app/common/pin-twillio-authy/pin-twillio-authy.module';
import { MatAutoCompleteHybridModule } from '@pg-app/shared/components/mat-autocomplete-hybrid/mat-autocomplete-hybrid.module';
import { AddNewRecipientComponent } from './components/add-new-recipient/add-new-recipient.component';
import { SwiftCharacterMessageModule } from '@pg-app/shared/components/swift-character-message/swift-character-message.module';
import { AddBeneficiaryStepComponent } from './components/add-beneficiary-step/add-beneficiary-step.component';
import { StepThreeComponent } from './components/add-new-recipient/step-three/step-three.component';
import { RemitterDetailsModule } from './components/add-new-recipient/remitter-details/remitter-details.module';


@NgModule({
  imports: [
    CommonModule,
    CoreUiModule,
    CoreMaterialModule,
    ReactiveFormsModule,
    ManageRecipientRoutingModule,
    NgTableModule,
    SendPaymentModalModule,
    FormsModule,
    PipeModule,
    PinTwillioAuthyModule,
    MatAutoCompleteHybridModule,
    SwiftCharacterMessageModule,
    RemitterDetailsModule
  ],
  declarations: [
    ManageRecipientComponent,
    AddNewRecipientStep1Component,
    AddNewRecipientStep2Component,
    AddNewRecipientVerifyCodeComponent,
    VerifyPasscodeComponent,
    AddNewRecipientComponent,
    AddBeneficiaryStepComponent,
    StepThreeComponent
  ],
  providers: [],
  entryComponents: [
    VerifyPasscodeComponent,
  ],
  exports: [
    ManageRecipientComponent,
    AddNewRecipientStep1Component,
    AddNewRecipientStep2Component,
    AddNewRecipientVerifyCodeComponent,
    VerifyPasscodeComponent,
    StepThreeComponent
  ]
})
export class ManageRecipientModule { }
